import { encryption } from '@utils/encryption';
import { checkHttpStatus, parseJSON, expiredToken, objectToQueryString, errorResponse, okResponseList } from '@utils/response';
import { Token, UserCode, EmployeeCode, Company } from '@users';

export function getSettings() {
    return fetch('chat/getsettings', {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getEmployeeUsers() {
    let url = 'chat/getEmployeeUsers?' + objectToQueryString({
        userCode: encryption(UserCode()),
        employeeCode: encryption(EmployeeCode()),
        company: encryption(Company()),
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponseList(JSON.parse(response.result));
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function loadPreviousChatHistory(konekUserAssociationIdAuthor, konekUserAssociationIdContact, minChatId) {
    let url = 'chat/loadPreviousChatHistory?' + objectToQueryString({
        userCode: encryption(UserCode()),
        employeeCode: encryption(EmployeeCode()),
        company: encryption(Company()),
        konekUserAssociationIdAuthor: encryption(konekUserAssociationIdAuthor),
        konekUserAssociationIdContact: encryption(konekUserAssociationIdContact),
        minChatId,
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponseList(JSON.parse(response.result));
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function savePrivateMessage(senderId, recipientId, message) {

    const param = JSON.stringify({        
        userCode: UserCode(),
        company: Company(),
        senderId,
        recipientId,
        message,
        token: Token()
    });

    return fetch('chat/savePrivateMessage', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: param
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function updateReadDatePrivateMessage(senderId, recipientId) {

    const param = JSON.stringify({
        userCode: UserCode(),
        company: Company(),
        senderId,
        recipientId,
        token: Token()
    });

    return fetch('chat/updateReadDatePrivateMessage', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: param
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortMessages(data) {
    return data.sort((msg1, msg2) => {
        return new Date(msg1.id) - new Date(msg2.id);
    });
}

export function sortLatestUsersMessage(data) {
    return data.sort((msg1, msg2) => {
        if ((!msg2.readDate && !msg1.readDate)
            || (msg2.readDate && msg1.readDate)) {
            return new Date(msg2.timestamp) - new Date(msg1.timestamp);
        }
        if (!msg2.readDate)
            return 1;
        if (!msg1.readDate)
            return -1;

        return 0;
    });
}

export function getInitials(fullName) {
    const initialTab = fullName.split(' ').map(part => part.charAt(0).toUpperCase());
    let initial = initialTab.join('');
    if (initialTab.length > 2) {
        initial = initialTab[0] + initialTab[initialTab.length - 1];
    }
    return initial;
}